import { forwardRef } from 'react';
import { css } from '@emotion/react';
import { motion, MotionProps } from 'motion/react';
import { useThemeValues } from '../../../hooks';
import { ContentLoader } from '../../loader';
import { useModalContext } from '../provider';

type FullscreenMobileModalBoxProps = {
  children: React.ReactNode;
  topOffset?: number;
};

const transition = { type: 'keyframes', stiffness: 260, damping: 20 };

const variants: MotionProps['variants'] = {
  hidden: {
    y: '100%',
  },
  visible: {
    y: '0%',
  },
  exit: {
    y: '100%',
  },
};
export const FullscreenMobileModalBox = forwardRef<HTMLElement, FullscreenMobileModalBoxProps>(
  ({ children, topOffset, ...rest }, ref) => {
    const { containerProps, loadingState } = useModalContext();
    const { zIndex, borderRadius, spacing } = useThemeValues();
    return (
      <motion.section
        {...containerProps}
        {...rest}
        ref={ref}
        css={css`
          width: 100%;
          height: calc(100% - ${topOffset}px);
          background: white;
          display: flex;
          flex-direction: column;
          overflow: auto;
          position: absolute;
          top: ${topOffset}px;
          left: 0;
          z-index: ${zIndex.modals};
          border-radius: ${borderRadius.medium};
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;

          :focus {
            outline: none;
          }
          .wv-modal-header {
            padding: ${spacing(2, 3)};
          }
          .wv-modal-footer {
            padding: ${spacing(2, 3)};
          }
        `}
        variants={variants}
        initial='hidden'
        animate='visible'
        exit='exit'
        transition={transition}
      >
        {children}
        <ContentLoader {...loadingState} />
      </motion.section>
    );
  }
);

FullscreenMobileModalBox.displayName = 'FullscreenMobileModalBox';
